import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import RouteService from '../../../services/RouteService';
import HelperNavigation from '../../common/HelperNavigation';
import globalTranslations from '../../../i18n/globalTranslations';
import Paths from '../../../types/Paths';
import MainOrderList from '../../order/MainOrderList';
import PageTitle from '../../common/PageTitle';
import SEOTitle from '../../head/SEOTitle';

@observer
export class MyAccountOrderList extends Component {
  getBreadcrumbsPath = () => {
    const { intl, routeService } = this.props;
    return routeService.transformBreadCrumbs([
      {
        text: intl.formatMessage(globalTranslations.myAccount),
        url: Paths.MyAccount,
      },
      {
        text: intl.formatMessage(globalTranslations.myOrderHistoryTitle),
        url: Paths.MyAccountOrderList,
      },
    ]);
  };

  render() {
    return (
      <Fragment>
        <HelperNavigation breadcrumbsPath={this.getBreadcrumbsPath()} />
        <div className="MyAccountOrderList">
          <SEOTitle title={globalTranslations.myOrderHistoryTitle} />
          <PageTitle>
            <FormattedMessage {...globalTranslations.myOrderHistoryTitle} />
          </PageTitle>
          <MainOrderList />
        </div>
      </Fragment>
    );
  }
}

MyAccountOrderList.propTypes = {
  intl: intlShape.isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired,
};

export default injectIntl(inject('routeService')(MyAccountOrderList));
